// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content {
  padding: 1rem;
  border-radius: 4px;
}

.form-row {
  margin-bottom: 1rem;
}

.field-label {
  display: block;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

.old-note {
  background-color: #f5f5f5;
  resize: none;
}

.error-text {
  color: #dc3545;
  font-size: 0.875rem;
  margin-top: 0.5rem;
}

.button-gap {
  gap: 0.5rem;
  padding: 1rem;
}

mat-dialog-content {
  max-height: 60vh;
  overflow-y: auto;
}
`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/project-details/spacer-details/spacer-test-append-note-dialog/spacer-test-append-note-dialog.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":[".content {\n  padding: 1rem;\n  border-radius: 4px;\n}\n\n.form-row {\n  margin-bottom: 1rem;\n}\n\n.field-label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-size: 0.9rem;\n}\n\n.old-note {\n  background-color: #f5f5f5;\n  resize: none;\n}\n\n.error-text {\n  color: #dc3545;\n  font-size: 0.875rem;\n  margin-top: 0.5rem;\n}\n\n.button-gap {\n  gap: 0.5rem;\n  padding: 1rem;\n}\n\nmat-dialog-content {\n  max-height: 60vh;\n  overflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
